<h1 matDialogTitle>Shopify Sync</h1>
<mat-dialog-content>
  <mat-divider style="margin-bottom: 8px;"></mat-divider>
  <p class="mat-body-2">Sync automatic discounts and multi-use coupon codes from Shopify to AvantLink.</p>
  <p class="mat-body-2 subtitle-warn">Turning sync ON or OFF will erase all existing Discounts in AvantLink. <a target="_blank"
    href="{{environment.supportUrl}}/hc/en-us/articles/36568607071387-Shopify-Discount-Sync-Importing-Shopify-Automatic-Discounts-and-Coupon-Codes-as-Discounts-into-AvantLink">Learn More.</a></p>
  <div style="margin: 16px;">
    <mat-slide-toggle [formControl]="controls.syncSlideToggle" class="sync-toggle">
      @if(data?.shopifyDiscountsSyncing === true) {
        Turn Shopify Sync Off
      } @else {
        Turn Shopify Sync On
      }
    </mat-slide-toggle>
  </div>
  @if(controls.syncSlideToggle.value) {
    <mat-card style="margin-bottom: 8px;">
      <mat-card-header class="availability-header">
        <mat-card-title>Shopify Store</mat-card-title>
        <p class="mat-body-2">Please choose the Shopify Store you would like to import discounts from. Only one store can be chosen.</p>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field style="width: 240px;">
          <mat-label>
            Shopify Store Name
          </mat-label>
          <mat-select [formControl]="controls.shopNameSelect">
            @for (shop of data.shopifyShopNames; track shop.shop_name) {
              <mat-option [value]="shop.shop_name">{{shop.shop_name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-header class="availability-header">
        <mat-card-title>Default Affiliate Availability</mat-card-title>
        <p class="mat-body-2">Applies to newly imported discounts only. Discounts can be designated to specific affiliate(s) after import.</p>
      </mat-card-header>
      <mat-card-content>
        <div class="mat-body-2" style="margin-top: 16px;">Automatic Discounts</div>
        <mat-radio-group [formControl]="controls.automaticDiscountsRadioButton">
          <mat-radio-button value="noAffiliates">Unavailable to affiliates</mat-radio-button>
          <mat-radio-button value="allAffiliates">Available to all affiliates</mat-radio-button>
        </mat-radio-group>
        <div class="mat-body-2">Multi-Use Coupon Codes</div>
        <mat-radio-group [formControl]="controls.couponCodesRadioButton">
          <mat-radio-button value="noAffiliates">Unavailable to affiliates</mat-radio-button>
          <mat-radio-button value="allAffiliates">Available to all affiliates</mat-radio-button>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="white" (click)="onCancelClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSaveButtonClick()" [disabled]="formFieldGroup.invalid || isTheSameFromInitial() || hasSubmitBeenClicked()">Save</button>
</mat-dialog-actions>

<ng-template #discardUnsavedChangesDialog>
  <h2 class="mat-h2" mat-dialog-title>Discard Unsaved Changes?</h2>
  <mat-dialog-content>
    <mat-divider></mat-divider>
    <p>You have unsaved changes that will be lost.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="white" mat-button mat-dialog-close>Keep Editing</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>OK</button>
  </mat-dialog-actions>
</ng-template>
